export default __webpack_public_path__ + "static/char-s-30-zh-Hans-dda5f5ce6bea77b0c7016e1a17a27a9f.png";